module.exports = __webpack_public_path__ + "static/media/portrait_original.ccdd9a15.jpg";